@if (wallets?.length === 0) {
  <div class="account-empty">
    <div class="account-empty__thumb">
      <picture>
        <source media="(min-width: 768px)" srcset="/assets/img/wallet-lg.svg">
        <source srcset="/assets/img/wallet.svg">
        <img src="/assets/img/wallet-lg.svg" alt="" class="img-fluid">
      </picture>
    </div>
    <div class="account-empty__content account-empty__content--md">
      <h3 class="mb-20">Welcome to your Wallet</h3>
      <div class="rte mb-30">
        <p class="font-16">Store and withdraw cash, or pay money towards your premium with your digital Everything.Insure wallet.</p>
        <p class="font-16">To start earning money refer your friends and get a percentage cash back after every month of paying your insurance policy premiums!</p>
      </div>
    </div>
    <div class="account-empty__btn">
      <a href="everything.account.wallet.html" data-toggle="modal" class="button button--lg button--primary">Get a Quote</a>
      <div class="mt-15">
      </div>
    </div>
  </div>
}



@if (wallets?.length > 0) {
  <h4 class="mb-25">Wallets</h4>
  <!-- whole wallet clickable -->
  @for (id of wallet_ids; track id) {
    <div class="wallet wallet--user">
      <div class="wallet__header">
        <div class="wallet__header-title">
          <h5>Bongani</h5>
        </div>
        <div class="wallet__header-arrow">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </div>
      </div>
      <div class="wallet__content">
        <div class="wallet__content-balance">
          <small>Balance</small>
          <p><strong>{{getBalance(id)}}</strong></p>
        </div>
        <div class="wallet__content-btns">
          <a href="#payment-modal" data-toggle="modal" class="button button--block button--ml button--outline">Pay</a>
          <a href="#withdraw-cash-modal" data-toggle="modal"
          class="button button--block button--ml button--white">Withdraw</a>
        </div>
      </div>
    </div>
  }
  <!-- <div class="wallet wallet--personal">
  <div class="wallet__header">
    <div class="wallet__header-title">
      <h5>Fire at Home</h5>
      <p>Claim Ref No. MNR1946</p>
    </div>
    <div class="wallet__header-arrow">
      <svg class="icon">
        <use xlink:href="#arrow-left-small"></use>
      </svg>
    </div>
  </div>
  <div class="wallet__content">
    <div class="wallet__content-balance">
      <small>Balance</small>
      <p><strong>R 200 000</strong>.00</p>
    </div>
    <div class="wallet__content-btns">
      <a href="#withdraw-cash-modal" data-toggle="modal"
      class="button button--block button--ml button--white">Withdraw</a>
    </div>
  </div>
</div>
<div class="wallet wallet--business">
  <div class="wallet__header">
    <div class="wallet__header-title">
      <h5>Suzuki Crash</h5>
      <p>Claim Ref No. MNR1886</p>
    </div>
    <div class="wallet__header-arrow">
      <svg class="icon">
        <use xlink:href="#arrow-left-small"></use>
      </svg>
    </div>
  </div>
  <div class="wallet__content">
    <div class="wallet__content-balance">
      <small>Balance</small>
      <p><strong>R 50 000</strong>.00</p>
    </div>
    <div class="wallet__content-btns">
      <a href="#withdraw-cash-modal" data-toggle="modal"
      class="button button--block button--ml button--white">Withdraw</a>
    </div>
  </div>
</div> -->
}


